import ContactForm from '@/components/sections/ContactForm'
import HeroSection from '@/components/sections/HeroSection'
import { sectionsMap as sharedSectionsMap } from '@/components/sections/shared'
import TextBlock from '@/components/sections/TextBlock'

export const sectionsMap: any = {
  contact_form: ContactForm,
  hero_section: HeroSection,
  text_block: TextBlock,
  ...sharedSectionsMap
}
